/**
 * Окно при первом запуске (решение заказчика 2026-10-11): новому лиду —
 * «за новыми настройками напиши в поддержку» с кнопкой на чат сапорта.
 * Показывается один раз: отметку ставим сразу при показе, а не по кнопке,
 * чтобы окно не всплывало на каждом открытии у тех, кто его просто закрыл.
 */
import { useEffect } from 'react';
import { SheetPortal } from './SheetPortal.js';
import { api } from '../lib/api.js';
import { haptic, openTelegramLink } from '../lib/telegram.js';
import { useApp } from '../state/app.js';

export function SupportPrompt({
  supportLink,
  brandName,
  onClose,
}: {
  supportLink: string;
  brandName: string;
  onClose: () => void;
}) {
  const { t } = useApp();

  useEffect(() => {
    void api.supportPromptSeen().catch(() => undefined);
  }, []);

  return (
    <SheetPortal>
      <div
        className="sheet-backdrop"
        onClick={(event) => {
          if (event.target === event.currentTarget) onClose();
        }}
      >
        <div className="sheet">
          <div className="sheet-handle" />
          <span className="kicker">{brandName}</span>
          <h2 className="sheet-title-grad">{t('app.support_prompt.title')}</h2>
          <p className="sheet-text">{t('app.support_prompt.text')}</p>
          <div className="stack" style={{ marginTop: 14 }}>
            <button
              type="button"
              className="cta cta-block"
              onClick={() => {
                haptic();
                openTelegramLink(supportLink);
                onClose();
              }}
            >
              {t('app.support_prompt.button')}
            </button>
            <button type="button" className="cta cta-secondary cta-block" onClick={onClose}>
              {t('app.support_prompt.later')}
            </button>
          </div>
        </div>
      </div>
    </SheetPortal>
  );
}
